/* ROSTR storefront behaviour. Vanilla, no dependencies. */

/* ---------- Drawers (native <dialog>) ---------- */

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-rostr-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.rostrOpen);
    if (dialog instanceof HTMLDialogElement) {
      event.preventDefault();
      dialog.returnFocusTo = opener;
      dialog.showModal();
      document.documentElement.classList.add('rostr-scroll-lock');
    }
    return;
  }

  const closer = event.target.closest('[data-rostr-close]');
  if (closer) {
    closer.closest('dialog')?.close();
    return;
  }

  if (event.target instanceof HTMLDialogElement && event.target.classList.contains('rostr-drawer')) {
    event.target.close();
  }
});

document.addEventListener(
  'close',
  (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('rostr-drawer')) return;
    document.documentElement.classList.remove('rostr-scroll-lock');
    dialog.returnFocusTo?.focus();
  },
  true
);

/* ---------- Recently viewed ---------- */

const RECENT_KEY = 'rostr:recently-viewed';
const RECENT_MAX = 12;

function readRecent() {
  try {
    const value = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}

function writeRecent(list) {
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
  } catch {
    /* storage unavailable: private mode or blocked */
  }
}

const currentProduct = document.querySelector('[data-rostr-product-handle]');
const currentHandle = currentProduct?.dataset.rostrProductHandle;

class RostrRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const limit = Number(this.dataset.limit || 4);
    const handles = readRecent()
      .filter((handle) => handle !== currentHandle)
      .slice(0, limit);

    if (!handles.length) return;

    const root = window.Shopify?.routes?.root || '/';
    const cards = await Promise.all(
      handles.map((handle) =>
        fetch(`${root}products/${encodeURIComponent(handle)}?view=rostr-card`)
          .then((response) => (response.ok ? response.text() : ''))
          .catch(() => '')
      )
    );

    const list = this.querySelector('[data-rostr-recent-list]');
    const html = cards.filter((card) => card.trim().startsWith('<li')).join('');
    if (!list || !html) return;

    list.innerHTML = html;
    this.hidden = false;
  }
}

if (!customElements.get('rostr-recently-viewed')) {
  customElements.define('rostr-recently-viewed', RostrRecentlyViewed);
}

if (currentHandle) {
  writeRecent([currentHandle, ...readRecent().filter((handle) => handle !== currentHandle)]);
}

/* ---------- Carousels: keep off-screen slides out of the tab order ---------- */

function syncInertSlides(root = document) {
  root.querySelectorAll('slideshow-slide').forEach((slide) => {
    slide.inert = slide.getAttribute('aria-hidden') === 'true';
  });
}

syncInertSlides();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes' && mutation.target.localName === 'slideshow-slide') {
      mutation.target.inert = mutation.target.getAttribute('aria-hidden') === 'true';
    } else if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => node instanceof Element && syncInertSlides(node));
    }
  }
}).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
